
import toast from "react-hot-toast";

let isLoggingOut = false;
export const handleLogout = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  localStorage.clear();  
  toast.error("Token Expired... Login Again")
  window.location.href = "/"; // or use router.push('/')
};
